import { connect } from 'react-redux';
import map from 'lodash/map';

import Accordion from './accordion.jsx';

import {
  getContentItemByUuid,
  getOpenIndicesForAccordion,
  getOrderedContentUuidsForSection,
  getSectionSelectedContent
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  setOpenIndicesForAccordion
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

export const mapStateToProps = (state, { section }) => {
  const contentItems = map(
    getOrderedContentUuidsForSection(state, section), 
    (uuid) => getContentItemByUuid(state, uuid)
  );

  const openIndices = getOpenIndicesForAccordion(state, section.id);
  const selectedContentItem = getSectionSelectedContent(state, section.id);

  return {
    uuid: section.id,
    items: contentItems,
    openIndexOverrides: openIndices,
    defaultOpenItemKeys: section.isFirstItemOpenByDefault && [0],
    maxOpenItemsLimit: section.isOneItemOpenLimited && 1,
    selectedContentItem
  };
};

export const mapDispatchToProps = (dispatch, { section })=> {
  return {
    onResetOpenIndexOverrides: ()=> {
      dispatch(setOpenIndicesForAccordion(section.id, undefined));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Accordion);
